
/*!

=========================================================
* Vue Argon Dashboard PRO - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import { brandContext } from './brand/brandContext';
import i18n from './i18n';

import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';
import axios from 'axios'
// router setup
import router from './routes/router';
import LoadScript from 'vue-plugin-load-script';
//walkthrough
import VueIntro from 'vue-introjs';
import 'intro.js/introjs.css';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import CryptoJS from "crypto-js";
// import { VueReCaptcha } from 'vue-recaptcha-v3';

import './assets/css/styles.css';
// import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'

brandContext.boot(); // loads saved branding + sets CSS vars

// Safe Dig Indiana: load blue theme CSS and set brand when company is safedig
const companyFrontend = process.env.VUE_APP_COMPANY_NAME_FRONTEND || '';
if (companyFrontend === 'safedig') {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = '/safedig_custom.css';
  document.head.appendChild(link);
  document.body.classList.add('safedig-theme');
  // Set Safe Dig blue and logo as default brand when no company branding stored
  if (!localStorage.getItem('hot.brandCtx')) {
    brandContext.set({
      primary_color: '#3e7799',
      secondary_color: '#2d5a73',
      slug: 'safedig',
      company_name: 'Safe Dig Indiana',
      logo_url: '/safedig-dashboard-logo.png',
      is_active: true
    });
  }
}

// Whopperco (Burger King franchise training): load BK theme + set brand
if (companyFrontend === 'whopperco') {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = '/whopperco_custom.css';
  document.head.appendChild(link);
  document.body.classList.add('whopperco-theme');
  const favicon = document.querySelector("link[rel~='icon']");
  if (favicon) favicon.href = '/whopperco-favicon.png';
  // Always overwrite — older sessions stored my placeholder /whopperco-dashboard-logo.png
  // which renders as a red gradient bar in the sidebar header.
  brandContext.set({
    primary_color: '#D62300',
    secondary_color: '#502314',
    slug: 'whopperco',
    company_name: 'Whopperco',
    logo_url: '/signup-img/whopperco/bk-logo.png',
    is_active: true
  });
}

Vue.use(Toast, {
  position: 'top-right',
  timeout: false, // don't auto-close unless you want to
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  // closeButton: true,
  showCloseButtonOnHover: false, // ✅ always visible
  closeButton: "button", // ✅ explicitly use default button
  // showCloseButtonOnHover: true,
});

// Vue.use(VueReCaptcha, {
//   siteKey: '6LdBqGcrAAAAAIhWgNhL5P-KPaB30WyXPtosz8H6', // your site key
//   loaderOptions: {
//     autoHideBadge: true, // hides the bottom-right badge
//   }
// });

Vue.use(LoadScript);
// plugin setup
Vue.use(DashboardPlugin);
// Vue.use(ElementPlus)
// plugin setup
Vue.use(VueIntro);
Vue.prototype.$baseUrl= process.env.VUE_APP_API_URL || 'http://localhost/home-of-training-merged/backend/public/';
Vue.prototype.$downloadUrl= process.env.VUE_APP_DOWNLOAD_URL || 'http://localhost:8000';

const SECRET_KEY = "Train321";
const _setItem = localStorage.setItem;
const _getItem = localStorage.getItem;
// testing
Storage.prototype.setItem = function (key, value) {
  try {
    const rawValue = typeof value === "string" ? value : JSON.stringify(value);
    const encrypted = CryptoJS.AES.encrypt(rawValue, SECRET_KEY).toString();
    return _setItem.call(this, key, encrypted);
  } catch (err) {
    console.warn("Encryption failed, saving as plain:", err);
    return _setItem.call(this, key, value);
  }
};

Storage.prototype.getItem = function (key) {
  const value = _getItem.call(this, key);
  if (!value) return null;

  try {
    const bytes = CryptoJS.AES.decrypt(value, SECRET_KEY);
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);

    if (decrypted) {
      return decrypted;
    }
  } catch {
    return value;
  }

};

let headers = {
  authorization: 'Bearer '+localStorage.getItem("hot-token"),
  'content-type': 'application/json'
}

Vue.prototype.$http = axios.create({
    baseURL: process.env.VUE_APP_API_URL || 'http://localhost:8000/',
    headers
});

// before a request is made start the nprogress
Vue.prototype.$http.interceptors.request.use(config => {
  NProgress.start();
  return config
}, error => {
  // Do something with request error
  return Promise.reject(error);
});

// before a response is returned stop nprogress
Vue.prototype.$http.interceptors.response.use(response => {
  NProgress.done();
  return response
}, error => {
  NProgress.done();
  return Promise.reject(error);
});


  // (function(h,o,t,j,a,r){
  //     h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
  //     h._hjSettings={hjid:6380429,hjsv:6};
  //     a=o.getElementsByTagName('head')[0];
  //     r=o.createElement('script');r.async=1;
  //     r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
  //     a.appendChild(r);
  // })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');


/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  render: h => h(App),
  router
});
